import React, { useMemo, useCallback, useRef } from "react";

import { useResult } from "2g-grid";
import { Theme as WidgetTheme } from "2g-widget";
import { Icons } from "2g-icons";
import { useDialogsProvider } from "2g-dialogs-provider";
import ZpracDialog from "2g-zprac-dialog";

import { useRedirect } from "b2b/hooks";
import { ADMIN, DATA } from "b2b/api/paths";
import { PATHS } from "b2b/constants";

import useMessages from "./i18n/useMessages";
import useColumns from "./useColumns";

export default function useSmlouvyGrid({ ico }) {
  const gridResultRef = useRef();
  const redirect = useRedirect();
  const { add, title, deleteDialogTitle, deleteDialogConfirm } = useMessages();
  const { showDialog, hideDialog } = useDialogsProvider();

  const redirectToVytvoreni = useCallback(() => {
    redirect(PATHS.ADMINISTRACE.ZAKAZNIK_SMLOUVA, {
      ico
    });
  }, [ico]);

  const handleEdit = useCallback(
    ({ dataRow: smlouva }) => {
      redirect(PATHS.ADMINISTRACE.ZAKAZNIK_SMLOUVA, {
        ico,
        id: smlouva.id
      });
    },
    [ico]
  );

  const handleDeleteSuccess = useCallback(() => {
    gridResultRef.current.reload();
  }, []);

  const handleDelete = useCallback(
    ({ dataRow: smlouva }) => {
      showDialog(ZpracDialog, {
        url: ADMIN.smlouva(smlouva.id),
        method: "delete",
        title: deleteDialogTitle(),
        confirmMessage: deleteDialogConfirm(),
        onClose: hideDialog,
        onSuccess: handleDeleteSuccess
      });
    },
    [showDialog, hideDialog, handleDeleteSuccess]
  );

  const columns = useColumns({ handleDelete });

  const titleActions = useMemo(
    () => ({
      add: () => (
        <WidgetTheme.HeaderAction key="add" onClick={redirectToVytvoreni}>
          <Icons.Plus />
          <span>{add()}</span>
        </WidgetTheme.HeaderAction>
      )
    }),
    [add, redirectToVytvoreni]
  );

  gridResultRef.current = useResult({
    moduleKey: "smlouvyGrid",
    title: title(),
    url: DATA.smlouvy(ico),
    method: "get",
    collapsed: true,
    columns,
    onRowClick: handleEdit,
    rowId: data => data.id,
    showFilterDescription: false,
    selectable: false,
    sortable: true,
    loadOnInit: true,
    titleActions
  });

  return gridResultRef.current;
}
